"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NRail Gateway Service API
 * NRail Gateway Service API
 *
 * The version of the OpenAPI document: 1.0.4
 * Contact: it@nrail.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApiFp = exports.ServiceApiAxiosParamCreator = exports.ReportsApi = exports.ReportsApiFactory = exports.ReportsApiFp = exports.ReportsApiAxiosParamCreator = exports.MobileApi = exports.MobileApiFactory = exports.MobileApiFp = exports.MobileApiAxiosParamCreator = exports.MetaApi = exports.MetaApiFactory = exports.MetaApiFp = exports.MetaApiAxiosParamCreator = exports.MapsApi = exports.MapsApiFactory = exports.MapsApiFp = exports.MapsApiAxiosParamCreator = exports.InternalApi = exports.InternalApiFactory = exports.InternalApiFp = exports.InternalApiAxiosParamCreator = exports.ExportsApi = exports.ExportsApiFactory = exports.ExportsApiFp = exports.ExportsApiAxiosParamCreator = exports.AnalysisApi = exports.AnalysisApiFactory = exports.AnalysisApiFp = exports.AnalysisApiAxiosParamCreator = exports.WeatherLanguageEnum = exports.WeatherSourceEnum = exports.UsersVehicleVehicleEngineEnum = exports.UsersVehicleVehicleTypeEnum = exports.UsersVehicleBoxStatusEnum = exports.UsersVehicleBoxTypeEnum = exports.TypeOfNotification = exports.StatusVehicle = exports.SimpleLiveLiveStatusVehicleEnum = exports.ServiceStatusProductionModeEnum = exports.ServiceStatusTokenRevocationServiceStatusEnum = exports.ServiceStatusUserManagementStatusEnum = exports.ServiceStatusDatabaseConnectionStatusEnum = exports.MapsLiveLiveStatusVehicleEnum = exports.LiveMobileLiveStatusVehicleEnum = exports.LiveLiveStatusVehicleEnum = exports.GetServiceReadiness500ResponseStatusEnum = exports.GetServiceLiveness500ResponseStatusEnum = exports.GetServiceLiveness200ResponseStatusEnum = exports.ExportNotificationByIdElementTypeEnum = void 0;
exports.TestsApi = exports.TestsApiFactory = exports.TestsApiFp = exports.TestsApiAxiosParamCreator = exports.ServiceApi = exports.ServiceApiFactory = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.ExportNotificationByIdElementTypeEnum = {
    Speeding: 'speeding',
    HighAcceleration: 'high acceleration'
};
exports.GetServiceLiveness200ResponseStatusEnum = {
    Ok: 'ok'
};
exports.GetServiceLiveness500ResponseStatusEnum = {
    NotAlive: 'not_alive'
};
exports.GetServiceReadiness500ResponseStatusEnum = {
    NotReady: 'not_ready'
};
exports.LiveLiveStatusVehicleEnum = {
    Driving: 'driving',
    Off: 'off',
    Equipped: 'equipped',
    Idl: 'idl'
};
exports.LiveMobileLiveStatusVehicleEnum = {
    Driving: 'driving',
    Off: 'off',
    Equipped: 'equipped',
    Idl: 'idl'
};
exports.MapsLiveLiveStatusVehicleEnum = {
    Driving: 'driving',
    Off: 'off',
    Equipped: 'equipped',
    Idl: 'idl'
};
exports.ServiceStatusDatabaseConnectionStatusEnum = {
    Ok: 'ok',
    Error: 'error'
};
exports.ServiceStatusUserManagementStatusEnum = {
    Ok: 'ok',
    Error: 'error'
};
exports.ServiceStatusTokenRevocationServiceStatusEnum = {
    Started: 'started',
    StartedCacheOnly: 'started_cache_only',
    Stopped: 'stopped',
    Error: 'error'
};
exports.ServiceStatusProductionModeEnum = {
    Production: 'production',
    Staging: 'staging',
    Testing: 'testing',
    Integration: 'integration',
    Development: 'development'
};
exports.SimpleLiveLiveStatusVehicleEnum = {
    Driving: 'Driving',
    Off: 'Off',
    Equipped: 'Equipped'
};
/**
 * description
 * @export
 * @enum {string}
 */
exports.StatusVehicle = {
    Driving: 'Driving',
    Off: 'Off',
    Equipped: 'Equipped'
};
/**
 * description
 * @export
 * @enum {string}
 */
exports.TypeOfNotification = {
    Speeding: 'speeding',
    HighAcceleration: 'high acceleration'
};
exports.UsersVehicleBoxTypeEnum = {
    Paula: 'Paula',
    Laura: 'Laura',
    Ella: 'Ella'
};
exports.UsersVehicleBoxStatusEnum = {
    Mounted: 'mounted',
    Offline: 'offline',
    Online: 'online',
    SortedOut: 'sorted out',
    NRail: 'NRail',
    STec: 'S-Tec',
    Send: 'send',
    Defect: 'defect',
    Mrs: 'MRS',
    InProduction: 'in production'
};
exports.UsersVehicleVehicleTypeEnum = {
    Locomotive: 'locomotive',
    Crane: 'crane'
};
exports.UsersVehicleVehicleEngineEnum = {
    Diesel: 'Diesel',
    Electric: 'electric'
};
exports.WeatherSourceEnum = {
    OpenWeatherMap: 'OpenWeatherMap',
    Darksky: 'Darksky'
};
exports.WeatherLanguageEnum = {
    De: 'de',
    En: 'en'
};
/**
 * AnalysisApi - axios parameter creator
 * @export
 */
const AnalysisApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary getPositionEnriched - Raw position Data of one or more vehicles within timespan
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DDThh:mm:ss.msZ
         * @param {number} userId description
         * @param {string} [vehicleIds] ID of Locomotive
         * @param {number} [timeSpanMinutes] description
         * @param {string} [owner] description
         * @param {boolean} [rdp] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionEnriched: async (startDate, userId, vehicleIds, timeSpanMinutes, owner, rdp, options = {}) => {
            // verify required parameter 'startDate' is not null or undefined
            common_1.assertParamExists('getPositionEnriched', 'startDate', startDate);
            // verify required parameter 'userId' is not null or undefined
            common_1.assertParamExists('getPositionEnriched', 'userId', userId);
            const localVarPath = `/analysis/position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString() :
                    startDate;
            }
            if (timeSpanMinutes !== undefined) {
                localVarQueryParameter['timeSpanMinutes'] = timeSpanMinutes;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (owner !== undefined) {
                localVarQueryParameter['owner'] = owner;
            }
            if (rdp !== undefined) {
                localVarQueryParameter['rdp'] = rdp;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AnalysisApiAxiosParamCreator = AnalysisApiAxiosParamCreator;
/**
 * AnalysisApi - functional programming interface
 * @export
 */
const AnalysisApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AnalysisApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary getPositionEnriched - Raw position Data of one or more vehicles within timespan
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DDThh:mm:ss.msZ
         * @param {number} userId description
         * @param {string} [vehicleIds] ID of Locomotive
         * @param {number} [timeSpanMinutes] description
         * @param {string} [owner] description
         * @param {boolean} [rdp] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionEnriched(startDate, userId, vehicleIds, timeSpanMinutes, owner, rdp, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionEnriched(startDate, userId, vehicleIds, timeSpanMinutes, owner, rdp, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.AnalysisApiFp = AnalysisApiFp;
/**
 * AnalysisApi - factory interface
 * @export
 */
const AnalysisApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AnalysisApiFp(configuration);
    return {
        /**
         *
         * @summary getPositionEnriched - Raw position Data of one or more vehicles within timespan
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DDThh:mm:ss.msZ
         * @param {number} userId description
         * @param {string} [vehicleIds] ID of Locomotive
         * @param {number} [timeSpanMinutes] description
         * @param {string} [owner] description
         * @param {boolean} [rdp] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionEnriched(startDate, userId, vehicleIds, timeSpanMinutes, owner, rdp, options) {
            return localVarFp.getPositionEnriched(startDate, userId, vehicleIds, timeSpanMinutes, owner, rdp, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AnalysisApiFactory = AnalysisApiFactory;
/**
 * AnalysisApi - object-oriented interface
 * @export
 * @class AnalysisApi
 * @extends {BaseAPI}
 */
class AnalysisApi extends base_1.BaseAPI {
    /**
     *
     * @summary getPositionEnriched - Raw position Data of one or more vehicles within timespan
     * @param {string} startDate Date from when to start the request Format: YYYY-MM-DDThh:mm:ss.msZ
     * @param {number} userId description
     * @param {string} [vehicleIds] ID of Locomotive
     * @param {number} [timeSpanMinutes] description
     * @param {string} [owner] description
     * @param {boolean} [rdp] description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    getPositionEnriched(startDate, userId, vehicleIds, timeSpanMinutes, owner, rdp, options) {
        return exports.AnalysisApiFp(this.configuration).getPositionEnriched(startDate, userId, vehicleIds, timeSpanMinutes, owner, rdp, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AnalysisApi = AnalysisApi;
/**
 * ExportsApi - axios parameter creator
 * @export
 */
const ExportsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This is the description
         * @summary getExportNotificationById - Get dataset to export notifications by vehicleId
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {number} [skip] description
         * @param {number} [top] description
         * @param {'asc' | 'desc'} [order] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportNotificationById: async (startDate, stopDate, vehicleIds, skip, top, order, options = {}) => {
            // verify required parameter 'startDate' is not null or undefined
            common_1.assertParamExists('getExportNotificationById', 'startDate', startDate);
            // verify required parameter 'stopDate' is not null or undefined
            common_1.assertParamExists('getExportNotificationById', 'stopDate', stopDate);
            const localVarPath = `/exports/notifications/by-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (stopDate !== undefined) {
                localVarQueryParameter['stopDate'] = (stopDate instanceof Date) ?
                    stopDate.toISOString().substr(0, 10) :
                    stopDate;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the description
         * @summary getExportReportById - Get dataset to export report by vehicleId
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {number} [skip] description
         * @param {number} [top] description
         * @param {'asc' | 'desc'} [order] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportReportById: async (startDate, stopDate, vehicleIds, skip, top, order, options = {}) => {
            // verify required parameter 'startDate' is not null or undefined
            common_1.assertParamExists('getExportReportById', 'startDate', startDate);
            // verify required parameter 'stopDate' is not null or undefined
            common_1.assertParamExists('getExportReportById', 'stopDate', stopDate);
            const localVarPath = `/exports/reports/by-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (stopDate !== undefined) {
                localVarQueryParameter['stopDate'] = (stopDate instanceof Date) ?
                    stopDate.toISOString().substr(0, 10) :
                    stopDate;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the description
         * @summary getExportReportByMetric - Get dataset to export reporting by Metric
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {number} [skip] description
         * @param {number} [top] description
         * @param {'asc' | 'desc'} [order] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportReportByMetric: async (startDate, stopDate, vehicleIds, skip, top, order, options = {}) => {
            // verify required parameter 'startDate' is not null or undefined
            common_1.assertParamExists('getExportReportByMetric', 'startDate', startDate);
            // verify required parameter 'stopDate' is not null or undefined
            common_1.assertParamExists('getExportReportByMetric', 'stopDate', stopDate);
            const localVarPath = `/exports/reports/by-metric`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (stopDate !== undefined) {
                localVarQueryParameter['stopDate'] = (stopDate instanceof Date) ?
                    stopDate.toISOString().substr(0, 10) :
                    stopDate;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ExportsApiAxiosParamCreator = ExportsApiAxiosParamCreator;
/**
 * ExportsApi - functional programming interface
 * @export
 */
const ExportsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ExportsApiAxiosParamCreator(configuration);
    return {
        /**
         * This is the description
         * @summary getExportNotificationById - Get dataset to export notifications by vehicleId
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {number} [skip] description
         * @param {number} [top] description
         * @param {'asc' | 'desc'} [order] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportNotificationById(startDate, stopDate, vehicleIds, skip, top, order, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportNotificationById(startDate, stopDate, vehicleIds, skip, top, order, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This is the description
         * @summary getExportReportById - Get dataset to export report by vehicleId
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {number} [skip] description
         * @param {number} [top] description
         * @param {'asc' | 'desc'} [order] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportReportById(startDate, stopDate, vehicleIds, skip, top, order, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportReportById(startDate, stopDate, vehicleIds, skip, top, order, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This is the description
         * @summary getExportReportByMetric - Get dataset to export reporting by Metric
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {number} [skip] description
         * @param {number} [top] description
         * @param {'asc' | 'desc'} [order] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportReportByMetric(startDate, stopDate, vehicleIds, skip, top, order, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportReportByMetric(startDate, stopDate, vehicleIds, skip, top, order, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ExportsApiFp = ExportsApiFp;
/**
 * ExportsApi - factory interface
 * @export
 */
const ExportsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ExportsApiFp(configuration);
    return {
        /**
         * This is the description
         * @summary getExportNotificationById - Get dataset to export notifications by vehicleId
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {number} [skip] description
         * @param {number} [top] description
         * @param {'asc' | 'desc'} [order] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportNotificationById(startDate, stopDate, vehicleIds, skip, top, order, options) {
            return localVarFp.getExportNotificationById(startDate, stopDate, vehicleIds, skip, top, order, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the description
         * @summary getExportReportById - Get dataset to export report by vehicleId
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {number} [skip] description
         * @param {number} [top] description
         * @param {'asc' | 'desc'} [order] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportReportById(startDate, stopDate, vehicleIds, skip, top, order, options) {
            return localVarFp.getExportReportById(startDate, stopDate, vehicleIds, skip, top, order, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the description
         * @summary getExportReportByMetric - Get dataset to export reporting by Metric
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {number} [skip] description
         * @param {number} [top] description
         * @param {'asc' | 'desc'} [order] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportReportByMetric(startDate, stopDate, vehicleIds, skip, top, order, options) {
            return localVarFp.getExportReportByMetric(startDate, stopDate, vehicleIds, skip, top, order, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ExportsApiFactory = ExportsApiFactory;
/**
 * ExportsApi - object-oriented interface
 * @export
 * @class ExportsApi
 * @extends {BaseAPI}
 */
class ExportsApi extends base_1.BaseAPI {
    /**
     * This is the description
     * @summary getExportNotificationById - Get dataset to export notifications by vehicleId
     * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
     * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
     * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
     * @param {number} [skip] description
     * @param {number} [top] description
     * @param {'asc' | 'desc'} [order] description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportsApi
     */
    getExportNotificationById(startDate, stopDate, vehicleIds, skip, top, order, options) {
        return exports.ExportsApiFp(this.configuration).getExportNotificationById(startDate, stopDate, vehicleIds, skip, top, order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the description
     * @summary getExportReportById - Get dataset to export report by vehicleId
     * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
     * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
     * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
     * @param {number} [skip] description
     * @param {number} [top] description
     * @param {'asc' | 'desc'} [order] description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportsApi
     */
    getExportReportById(startDate, stopDate, vehicleIds, skip, top, order, options) {
        return exports.ExportsApiFp(this.configuration).getExportReportById(startDate, stopDate, vehicleIds, skip, top, order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the description
     * @summary getExportReportByMetric - Get dataset to export reporting by Metric
     * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
     * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
     * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
     * @param {number} [skip] description
     * @param {number} [top] description
     * @param {'asc' | 'desc'} [order] description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportsApi
     */
    getExportReportByMetric(startDate, stopDate, vehicleIds, skip, top, order, options) {
        return exports.ExportsApiFp(this.configuration).getExportReportByMetric(startDate, stopDate, vehicleIds, skip, top, order, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ExportsApi = ExportsApi;
/**
 * InternalApi - axios parameter creator
 * @export
 */
const InternalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This is the description
         * @summary acknowledgeImei - Check, if an imei is valid and accepted by the system of NRail
         * @param {number} imei description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeImei: async (imei, options = {}) => {
            // verify required parameter 'imei' is not null or undefined
            common_1.assertParamExists('acknowledgeImei', 'imei', imei);
            const localVarPath = `/internal/acknowledgeImei`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (imei !== undefined) {
                localVarQueryParameter['imei'] = imei;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.InternalApiAxiosParamCreator = InternalApiAxiosParamCreator;
/**
 * InternalApi - functional programming interface
 * @export
 */
const InternalApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.InternalApiAxiosParamCreator(configuration);
    return {
        /**
         * This is the description
         * @summary acknowledgeImei - Check, if an imei is valid and accepted by the system of NRail
         * @param {number} imei description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acknowledgeImei(imei, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acknowledgeImei(imei, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.InternalApiFp = InternalApiFp;
/**
 * InternalApi - factory interface
 * @export
 */
const InternalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.InternalApiFp(configuration);
    return {
        /**
         * This is the description
         * @summary acknowledgeImei - Check, if an imei is valid and accepted by the system of NRail
         * @param {number} imei description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeImei(imei, options) {
            return localVarFp.acknowledgeImei(imei, options).then((request) => request(axios, basePath));
        },
    };
};
exports.InternalApiFactory = InternalApiFactory;
/**
 * InternalApi - object-oriented interface
 * @export
 * @class InternalApi
 * @extends {BaseAPI}
 */
class InternalApi extends base_1.BaseAPI {
    /**
     * This is the description
     * @summary acknowledgeImei - Check, if an imei is valid and accepted by the system of NRail
     * @param {number} imei description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    acknowledgeImei(imei, options) {
        return exports.InternalApiFp(this.configuration).acknowledgeImei(imei, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.InternalApi = InternalApi;
/**
 * MapsApi - axios parameter creator
 * @export
 */
const MapsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This is the description
         * @summary getHeatmap - Get data to visualize the heatmap at the frontend
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeatmap: async (startDate, stopDate, vehicleIds, options = {}) => {
            // verify required parameter 'startDate' is not null or undefined
            common_1.assertParamExists('getHeatmap', 'startDate', startDate);
            // verify required parameter 'stopDate' is not null or undefined
            common_1.assertParamExists('getHeatmap', 'stopDate', stopDate);
            const localVarPath = `/maps/heatmap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (stopDate !== undefined) {
                localVarQueryParameter['stopDate'] = (stopDate instanceof Date) ?
                    stopDate.toISOString().substr(0, 10) :
                    stopDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the description
         * @summary getLivePosition - Get data to visualize the live position of multible vehicles on a map
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLivePosition: async (vehicleIds, options = {}) => {
            const localVarPath = `/maps/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the description
         * @summary getTracks - Get data to visualize tracks at the frontend
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTracks: async (startDate, stopDate, vehicleIds, options = {}) => {
            // verify required parameter 'startDate' is not null or undefined
            common_1.assertParamExists('getTracks', 'startDate', startDate);
            // verify required parameter 'stopDate' is not null or undefined
            common_1.assertParamExists('getTracks', 'stopDate', stopDate);
            const localVarPath = `/maps/tracks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (stopDate !== undefined) {
                localVarQueryParameter['stopDate'] = (stopDate instanceof Date) ?
                    stopDate.toISOString().substr(0, 10) :
                    stopDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MapsApiAxiosParamCreator = MapsApiAxiosParamCreator;
/**
 * MapsApi - functional programming interface
 * @export
 */
const MapsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MapsApiAxiosParamCreator(configuration);
    return {
        /**
         * This is the description
         * @summary getHeatmap - Get data to visualize the heatmap at the frontend
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHeatmap(startDate, stopDate, vehicleIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHeatmap(startDate, stopDate, vehicleIds, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This is the description
         * @summary getLivePosition - Get data to visualize the live position of multible vehicles on a map
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLivePosition(vehicleIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLivePosition(vehicleIds, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This is the description
         * @summary getTracks - Get data to visualize tracks at the frontend
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTracks(startDate, stopDate, vehicleIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTracks(startDate, stopDate, vehicleIds, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.MapsApiFp = MapsApiFp;
/**
 * MapsApi - factory interface
 * @export
 */
const MapsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MapsApiFp(configuration);
    return {
        /**
         * This is the description
         * @summary getHeatmap - Get data to visualize the heatmap at the frontend
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeatmap(startDate, stopDate, vehicleIds, options) {
            return localVarFp.getHeatmap(startDate, stopDate, vehicleIds, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the description
         * @summary getLivePosition - Get data to visualize the live position of multible vehicles on a map
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLivePosition(vehicleIds, options) {
            return localVarFp.getLivePosition(vehicleIds, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the description
         * @summary getTracks - Get data to visualize tracks at the frontend
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTracks(startDate, stopDate, vehicleIds, options) {
            return localVarFp.getTracks(startDate, stopDate, vehicleIds, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MapsApiFactory = MapsApiFactory;
/**
 * MapsApi - object-oriented interface
 * @export
 * @class MapsApi
 * @extends {BaseAPI}
 */
class MapsApi extends base_1.BaseAPI {
    /**
     * This is the description
     * @summary getHeatmap - Get data to visualize the heatmap at the frontend
     * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
     * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
     * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapsApi
     */
    getHeatmap(startDate, stopDate, vehicleIds, options) {
        return exports.MapsApiFp(this.configuration).getHeatmap(startDate, stopDate, vehicleIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the description
     * @summary getLivePosition - Get data to visualize the live position of multible vehicles on a map
     * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapsApi
     */
    getLivePosition(vehicleIds, options) {
        return exports.MapsApiFp(this.configuration).getLivePosition(vehicleIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the description
     * @summary getTracks - Get data to visualize tracks at the frontend
     * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
     * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
     * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapsApi
     */
    getTracks(startDate, stopDate, vehicleIds, options) {
        return exports.MapsApiFp(this.configuration).getTracks(startDate, stopDate, vehicleIds, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MapsApi = MapsApi;
/**
 * MetaApi - axios parameter creator
 * @export
 */
const MetaApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This is the description
         * @summary getLocoMetaData - Get metadata of a vehicle
         * @param {number} vehicleId ID of Locomotive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocoMetaData: async (vehicleId, options = {}) => {
            // verify required parameter 'vehicleId' is not null or undefined
            common_1.assertParamExists('getLocoMetaData', 'vehicleId', vehicleId);
            const localVarPath = `/vehicle/{vehicleId}/meta-data`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the description
         * @summary getUsersVehicles - Get metadata of a users vehicles
         * @param {number} userId ID of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersVehicles: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            common_1.assertParamExists('getUsersVehicles', 'userId', userId);
            const localVarPath = `/users/{userId}/vehicles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MetaApiAxiosParamCreator = MetaApiAxiosParamCreator;
/**
 * MetaApi - functional programming interface
 * @export
 */
const MetaApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MetaApiAxiosParamCreator(configuration);
    return {
        /**
         * This is the description
         * @summary getLocoMetaData - Get metadata of a vehicle
         * @param {number} vehicleId ID of Locomotive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocoMetaData(vehicleId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocoMetaData(vehicleId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This is the description
         * @summary getUsersVehicles - Get metadata of a users vehicles
         * @param {number} userId ID of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersVehicles(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersVehicles(userId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.MetaApiFp = MetaApiFp;
/**
 * MetaApi - factory interface
 * @export
 */
const MetaApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MetaApiFp(configuration);
    return {
        /**
         * This is the description
         * @summary getLocoMetaData - Get metadata of a vehicle
         * @param {number} vehicleId ID of Locomotive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocoMetaData(vehicleId, options) {
            return localVarFp.getLocoMetaData(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the description
         * @summary getUsersVehicles - Get metadata of a users vehicles
         * @param {number} userId ID of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersVehicles(userId, options) {
            return localVarFp.getUsersVehicles(userId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MetaApiFactory = MetaApiFactory;
/**
 * MetaApi - object-oriented interface
 * @export
 * @class MetaApi
 * @extends {BaseAPI}
 */
class MetaApi extends base_1.BaseAPI {
    /**
     * This is the description
     * @summary getLocoMetaData - Get metadata of a vehicle
     * @param {number} vehicleId ID of Locomotive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    getLocoMetaData(vehicleId, options) {
        return exports.MetaApiFp(this.configuration).getLocoMetaData(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the description
     * @summary getUsersVehicles - Get metadata of a users vehicles
     * @param {number} userId ID of user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    getUsersVehicles(userId, options) {
        return exports.MetaApiFp(this.configuration).getUsersVehicles(userId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MetaApi = MetaApi;
/**
 * MobileApi - axios parameter creator
 * @export
 */
const MobileApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This is the description
         * @summary getLiveMobile - Get live data specified for the mobile app
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveMobile: async (vehicleIds, options = {}) => {
            const localVarPath = `/mobile/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MobileApiAxiosParamCreator = MobileApiAxiosParamCreator;
/**
 * MobileApi - functional programming interface
 * @export
 */
const MobileApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MobileApiAxiosParamCreator(configuration);
    return {
        /**
         * This is the description
         * @summary getLiveMobile - Get live data specified for the mobile app
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLiveMobile(vehicleIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLiveMobile(vehicleIds, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.MobileApiFp = MobileApiFp;
/**
 * MobileApi - factory interface
 * @export
 */
const MobileApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MobileApiFp(configuration);
    return {
        /**
         * This is the description
         * @summary getLiveMobile - Get live data specified for the mobile app
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveMobile(vehicleIds, options) {
            return localVarFp.getLiveMobile(vehicleIds, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MobileApiFactory = MobileApiFactory;
/**
 * MobileApi - object-oriented interface
 * @export
 * @class MobileApi
 * @extends {BaseAPI}
 */
class MobileApi extends base_1.BaseAPI {
    /**
     * This is the description
     * @summary getLiveMobile - Get live data specified for the mobile app
     * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    getLiveMobile(vehicleIds, options) {
        return exports.MobileApiFp(this.configuration).getLiveMobile(vehicleIds, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MobileApi = MobileApi;
/**
 * ReportsApi - axios parameter creator
 * @export
 */
const ReportsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary getGraph - Data for the graphs to avoid loops in the frontend
         * @param {number} vehicleId ID of Locomotive
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraph: async (vehicleId, startDate, stopDate, options = {}) => {
            // verify required parameter 'vehicleId' is not null or undefined
            common_1.assertParamExists('getGraph', 'vehicleId', vehicleId);
            // verify required parameter 'startDate' is not null or undefined
            common_1.assertParamExists('getGraph', 'startDate', startDate);
            // verify required parameter 'stopDate' is not null or undefined
            common_1.assertParamExists('getGraph', 'stopDate', stopDate);
            const localVarPath = `/reports/graph`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (stopDate !== undefined) {
                localVarQueryParameter['stopDate'] = (stopDate instanceof Date) ?
                    stopDate.toISOString().substr(0, 10) :
                    stopDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the description
         * @summary getLive - Get live Data of multiple vehicles
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLive: async (vehicleIds, options = {}) => {
            const localVarPath = `/reports/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the description
         * @summary getPieChart - Get reporting data for the pie chart
         * @param {number} vehicleId ID of Locomotive
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {boolean} [showStandbyHours] description
         * @param {boolean} [showDrivingHours] description
         * @param {boolean} [showIdleHours] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieChart: async (vehicleId, startDate, stopDate, showStandbyHours, showDrivingHours, showIdleHours, options = {}) => {
            // verify required parameter 'vehicleId' is not null or undefined
            common_1.assertParamExists('getPieChart', 'vehicleId', vehicleId);
            // verify required parameter 'startDate' is not null or undefined
            common_1.assertParamExists('getPieChart', 'startDate', startDate);
            // verify required parameter 'stopDate' is not null or undefined
            common_1.assertParamExists('getPieChart', 'stopDate', stopDate);
            const localVarPath = `/reports/pie-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (stopDate !== undefined) {
                localVarQueryParameter['stopDate'] = (stopDate instanceof Date) ?
                    stopDate.toISOString().substr(0, 10) :
                    stopDate;
            }
            if (showStandbyHours !== undefined) {
                localVarQueryParameter['showStandbyHours'] = showStandbyHours;
            }
            if (showDrivingHours !== undefined) {
                localVarQueryParameter['showDrivingHours'] = showDrivingHours;
            }
            if (showIdleHours !== undefined) {
                localVarQueryParameter['showIdleHours'] = showIdleHours;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all Data necessary for the default reporting page of the Locomotive asked for.
         * @summary getReport - Most recent Reporting for one Loco
         * @param {number} vehicleId ID of Locomotive
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: async (vehicleId, startDate, stopDate, options = {}) => {
            // verify required parameter 'vehicleId' is not null or undefined
            common_1.assertParamExists('getReport', 'vehicleId', vehicleId);
            // verify required parameter 'startDate' is not null or undefined
            common_1.assertParamExists('getReport', 'startDate', startDate);
            // verify required parameter 'stopDate' is not null or undefined
            common_1.assertParamExists('getReport', 'stopDate', stopDate);
            const localVarPath = `/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (stopDate !== undefined) {
                localVarQueryParameter['stopDate'] = (stopDate instanceof Date) ?
                    stopDate.toISOString().substr(0, 10) :
                    stopDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the description
         * @summary getSimpleLive - Get simple live Data of multiple vehicles
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleLive: async (vehicleIds, options = {}) => {
            const localVarPath = `/reports/simple-live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is the description
         * @summary getWeatherInfo - Get weather info from the most recent position of an vehicle
         * @param {number} vehicleId ID of Locomotive
         * @param {'de' | 'en'} [language]
         * @param {'Darksky' | 'OpenWeatherMap'} [source] Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeatherInfo: async (vehicleId, language, source, options = {}) => {
            // verify required parameter 'vehicleId' is not null or undefined
            common_1.assertParamExists('getWeatherInfo', 'vehicleId', vehicleId);
            const localVarPath = `/reports/weather-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ReportsApiAxiosParamCreator = ReportsApiAxiosParamCreator;
/**
 * ReportsApi - functional programming interface
 * @export
 */
const ReportsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ReportsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary getGraph - Data for the graphs to avoid loops in the frontend
         * @param {number} vehicleId ID of Locomotive
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraph(vehicleId, startDate, stopDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraph(vehicleId, startDate, stopDate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This is the description
         * @summary getLive - Get live Data of multiple vehicles
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLive(vehicleIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLive(vehicleIds, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This is the description
         * @summary getPieChart - Get reporting data for the pie chart
         * @param {number} vehicleId ID of Locomotive
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {boolean} [showStandbyHours] description
         * @param {boolean} [showDrivingHours] description
         * @param {boolean} [showIdleHours] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPieChart(vehicleId, startDate, stopDate, showStandbyHours, showDrivingHours, showIdleHours, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPieChart(vehicleId, startDate, stopDate, showStandbyHours, showDrivingHours, showIdleHours, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Returns all Data necessary for the default reporting page of the Locomotive asked for.
         * @summary getReport - Most recent Reporting for one Loco
         * @param {number} vehicleId ID of Locomotive
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReport(vehicleId, startDate, stopDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReport(vehicleId, startDate, stopDate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This is the description
         * @summary getSimpleLive - Get simple live Data of multiple vehicles
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimpleLive(vehicleIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimpleLive(vehicleIds, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This is the description
         * @summary getWeatherInfo - Get weather info from the most recent position of an vehicle
         * @param {number} vehicleId ID of Locomotive
         * @param {'de' | 'en'} [language]
         * @param {'Darksky' | 'OpenWeatherMap'} [source] Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeatherInfo(vehicleId, language, source, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeatherInfo(vehicleId, language, source, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ReportsApiFp = ReportsApiFp;
/**
 * ReportsApi - factory interface
 * @export
 */
const ReportsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ReportsApiFp(configuration);
    return {
        /**
         *
         * @summary getGraph - Data for the graphs to avoid loops in the frontend
         * @param {number} vehicleId ID of Locomotive
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraph(vehicleId, startDate, stopDate, options) {
            return localVarFp.getGraph(vehicleId, startDate, stopDate, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the description
         * @summary getLive - Get live Data of multiple vehicles
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLive(vehicleIds, options) {
            return localVarFp.getLive(vehicleIds, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the description
         * @summary getPieChart - Get reporting data for the pie chart
         * @param {number} vehicleId ID of Locomotive
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {boolean} [showStandbyHours] description
         * @param {boolean} [showDrivingHours] description
         * @param {boolean} [showIdleHours] description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieChart(vehicleId, startDate, stopDate, showStandbyHours, showDrivingHours, showIdleHours, options) {
            return localVarFp.getPieChart(vehicleId, startDate, stopDate, showStandbyHours, showDrivingHours, showIdleHours, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all Data necessary for the default reporting page of the Locomotive asked for.
         * @summary getReport - Most recent Reporting for one Loco
         * @param {number} vehicleId ID of Locomotive
         * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
         * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(vehicleId, startDate, stopDate, options) {
            return localVarFp.getReport(vehicleId, startDate, stopDate, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the description
         * @summary getSimpleLive - Get simple live Data of multiple vehicles
         * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleLive(vehicleIds, options) {
            return localVarFp.getSimpleLive(vehicleIds, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the description
         * @summary getWeatherInfo - Get weather info from the most recent position of an vehicle
         * @param {number} vehicleId ID of Locomotive
         * @param {'de' | 'en'} [language]
         * @param {'Darksky' | 'OpenWeatherMap'} [source] Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeatherInfo(vehicleId, language, source, options) {
            return localVarFp.getWeatherInfo(vehicleId, language, source, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ReportsApiFactory = ReportsApiFactory;
/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
class ReportsApi extends base_1.BaseAPI {
    /**
     *
     * @summary getGraph - Data for the graphs to avoid loops in the frontend
     * @param {number} vehicleId ID of Locomotive
     * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
     * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getGraph(vehicleId, startDate, stopDate, options) {
        return exports.ReportsApiFp(this.configuration).getGraph(vehicleId, startDate, stopDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the description
     * @summary getLive - Get live Data of multiple vehicles
     * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getLive(vehicleIds, options) {
        return exports.ReportsApiFp(this.configuration).getLive(vehicleIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the description
     * @summary getPieChart - Get reporting data for the pie chart
     * @param {number} vehicleId ID of Locomotive
     * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
     * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
     * @param {boolean} [showStandbyHours] description
     * @param {boolean} [showDrivingHours] description
     * @param {boolean} [showIdleHours] description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getPieChart(vehicleId, startDate, stopDate, showStandbyHours, showDrivingHours, showIdleHours, options) {
        return exports.ReportsApiFp(this.configuration).getPieChart(vehicleId, startDate, stopDate, showStandbyHours, showDrivingHours, showIdleHours, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all Data necessary for the default reporting page of the Locomotive asked for.
     * @summary getReport - Most recent Reporting for one Loco
     * @param {number} vehicleId ID of Locomotive
     * @param {string} startDate Date from when to start the request Format: YYYY-MM-DD
     * @param {string} stopDate Date up to which to request (including the given day until the end) Format: YYYY-MM-DD Given 2020-02-01 will request all data up to 2020-02-01 23:59:59
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getReport(vehicleId, startDate, stopDate, options) {
        return exports.ReportsApiFp(this.configuration).getReport(vehicleId, startDate, stopDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the description
     * @summary getSimpleLive - Get simple live Data of multiple vehicles
     * @param {string} [vehicleIds] Multiple IDs of tracing objects in a string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getSimpleLive(vehicleIds, options) {
        return exports.ReportsApiFp(this.configuration).getSimpleLive(vehicleIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the description
     * @summary getWeatherInfo - Get weather info from the most recent position of an vehicle
     * @param {number} vehicleId ID of Locomotive
     * @param {'de' | 'en'} [language]
     * @param {'Darksky' | 'OpenWeatherMap'} [source] Description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    getWeatherInfo(vehicleId, language, source, options) {
        return exports.ReportsApiFp(this.configuration).getWeatherInfo(vehicleId, language, source, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ReportsApi = ReportsApi;
/**
 * ServiceApi - axios parameter creator
 * @export
 */
const ServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * test route
         * @summary getLandingPage - Landing page route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingPage: async (options = {}) => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the liveness of the service
         * @summary getServiceLiveness - Get service liveness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceLiveness: async (options = {}) => {
            const localVarPath = `/service/liveness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the readiness of the service
         * @summary Get service readiness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceReadiness: async (options = {}) => {
            const localVarPath = `/service/readiness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets status information for the service
         * @summary getServiceStatus - Get service status ✅
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatus: async (options = {}) => {
            const localVarPath = `/service/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * test route
         * @summary Test route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTest: async (options = {}) => {
            const localVarPath = `/service/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ServiceApiAxiosParamCreator = ServiceApiAxiosParamCreator;
/**
 * ServiceApi - functional programming interface
 * @export
 */
const ServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ServiceApiAxiosParamCreator(configuration);
    return {
        /**
         * test route
         * @summary getLandingPage - Landing page route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandingPage(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLandingPage(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets the liveness of the service
         * @summary getServiceLiveness - Get service liveness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceLiveness(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceLiveness(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets the readiness of the service
         * @summary Get service readiness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceReadiness(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceReadiness(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Gets status information for the service
         * @summary getServiceStatus - Get service status ✅
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceStatus(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * test route
         * @summary Test route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTest(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTest(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ServiceApiFp = ServiceApiFp;
/**
 * ServiceApi - factory interface
 * @export
 */
const ServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ServiceApiFp(configuration);
    return {
        /**
         * test route
         * @summary getLandingPage - Landing page route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingPage(options) {
            return localVarFp.getLandingPage(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the liveness of the service
         * @summary getServiceLiveness - Get service liveness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceLiveness(options) {
            return localVarFp.getServiceLiveness(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the readiness of the service
         * @summary Get service readiness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceReadiness(options) {
            return localVarFp.getServiceReadiness(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets status information for the service
         * @summary getServiceStatus - Get service status ✅
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatus(options) {
            return localVarFp.getServiceStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * test route
         * @summary Test route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTest(options) {
            return localVarFp.getTest(options).then((request) => request(axios, basePath));
        },
    };
};
exports.ServiceApiFactory = ServiceApiFactory;
/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
class ServiceApi extends base_1.BaseAPI {
    /**
     * test route
     * @summary getLandingPage - Landing page route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getLandingPage(options) {
        return exports.ServiceApiFp(this.configuration).getLandingPage(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the liveness of the service
     * @summary getServiceLiveness - Get service liveness
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getServiceLiveness(options) {
        return exports.ServiceApiFp(this.configuration).getServiceLiveness(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the readiness of the service
     * @summary Get service readiness
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getServiceReadiness(options) {
        return exports.ServiceApiFp(this.configuration).getServiceReadiness(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets status information for the service
     * @summary getServiceStatus - Get service status ✅
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getServiceStatus(options) {
        return exports.ServiceApiFp(this.configuration).getServiceStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * test route
     * @summary Test route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    getTest(options) {
        return exports.ServiceApiFp(this.configuration).getTest(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ServiceApi = ServiceApi;
/**
 * TestsApi - axios parameter creator
 * @export
 */
const TestsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This is the description
         * @summary Get most recent position of all ships and all workshops
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesAndShips: async (options = {}) => {
            const localVarPath = `/tests/companies-and-ships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TestsApiAxiosParamCreator = TestsApiAxiosParamCreator;
/**
 * TestsApi - functional programming interface
 * @export
 */
const TestsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TestsApiAxiosParamCreator(configuration);
    return {
        /**
         * This is the description
         * @summary Get most recent position of all ships and all workshops
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompaniesAndShips(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompaniesAndShips(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.TestsApiFp = TestsApiFp;
/**
 * TestsApi - factory interface
 * @export
 */
const TestsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TestsApiFp(configuration);
    return {
        /**
         * This is the description
         * @summary Get most recent position of all ships and all workshops
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesAndShips(options) {
            return localVarFp.getCompaniesAndShips(options).then((request) => request(axios, basePath));
        },
    };
};
exports.TestsApiFactory = TestsApiFactory;
/**
 * TestsApi - object-oriented interface
 * @export
 * @class TestsApi
 * @extends {BaseAPI}
 */
class TestsApi extends base_1.BaseAPI {
    /**
     * This is the description
     * @summary Get most recent position of all ships and all workshops
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    getCompaniesAndShips(options) {
        return exports.TestsApiFp(this.configuration).getCompaniesAndShips(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TestsApi = TestsApi;
//# sourceMappingURL=api.js.map